export default __webpack_public_path__ + "static/media/edibles.9a7692e5.png";